export * from './dist/multiselect.component';



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/node_modules/angular4-multiselect-dropdown/angular4-multiselect-dropdown.ts